/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {
  Modal,
} from 'ui-component-library/components';

import {
  ButtonsContainer,
  ModalButton,
  TextContainer,
} from './inactivity-modal.style';
import userManager from '../../../../../helpers/userManager';
// import { INACTIVITY_LOGOUT_TIME, INACTIVITY_WARNING_TIME } from '../../../utils/env';

/**
 * Inactivity modal component
 * @returns {void}
 */
const InactivityModal = () => {
  // State hook
  const [displayInactivityModal, setDisplayInactivityModal] = useState(false);

  /**
   * Sign a user out
   * @return {void}
   */
  const signOut = () => {
    userManager.signoutRedirect();
  };

  /**
   * Set Warning modal to display
   * @return {void}
   */
  const warn = () => {
    setDisplayInactivityModal(true);
  };
  /**
   * Log the user out
   * @return {void}
   */
  const logout = () => {
    signOut();
  };

  // Reset timeout when any of the events occur
  useEffect(() => {
    let warnTimeout;
    let logoutTimeout;

    const events = [
      'mousemove',
      'click',
      'scroll',
      'keypress',
    ];
    /**
   * Set the warning and logout timeouts
   * @return {void}
   */
    const setTimeouts = () => {
      const warnTime = 60 * 60000; // TODO: Fix env var implementation
      const logoutTime = 65 * 60000;
      warnTimeout = setTimeout(warn, warnTime);
      logoutTimeout = setTimeout(logout, logoutTime);
    };

    /**
   * clear the warning and logout timeouts
   * @return {void}
   */
    const clearTimeouts = () => {
      if (warnTimeout) clearTimeout(warnTimeout);
      if (logoutTimeout) clearTimeout(logoutTimeout);
    };

    /**
   * reset the timeouts to start again
   * @return {void}
   */
    const resetTimeouts = () => {
      clearTimeouts();
      setTimeouts();
    };

    events.forEach((event) => {
      window.addEventListener(event, resetTimeouts);
    });

    setTimeouts();

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimeouts);
        clearTimeouts();
      });
    };
  }, []);

  return (
    <div data-testid="Inactivity Modal">
      <Modal
        title="Session Expiring"
        isOpen={displayInactivityModal}
        headerContent={<div />}
        width="554px"
      >
        <TextContainer>
          You will be logged out soon due to inactivity.
          Click &quot;Keep me signed in&quot; to stay logged in and continue working.
        </TextContainer>
        <ButtonsContainer>
          <ModalButton
            text="LOG OUT"
            isSecondary
            onClick={signOut}
          />
          <ModalButton
            text="KEEP ME SIGNED IN"
            onClick={() => {
              setDisplayInactivityModal(false);
            }}
          />
        </ButtonsContainer>
      </Modal>
    </div>
  );
};

export default InactivityModal;
